module.exports = __webpack_public_path__ + "img/7-full-sm.6a9ad007.jpg";